import { OrganizedController } from './organized.controller'

function organized () {
  return {
    restrict: 'E',
    scope: {
      modalState: '<',
      allowedAssetExtensionsSelection: '<',
      singleAttach: '<',
      removeExtensions: '<',
      showOnlyExtension: '<'
    },
    templateUrl: '/repository/directives/organized/organized-directive.html?$$REVISION$$',
    controller: OrganizedController
  }
}

export { organized }
